import React, { Component, useEffect, useRef, useState } from "react";

import { connect } from "react-redux";
import { withNamespaces } from "react-i18next";
import { InputNumber, Table, Select, Button, message, Upload } from "antd";
import {
  EditOutlined,
  DeleteOutlined,
  DownloadOutlined,
} from "@ant-design/icons";
import ProductsSelectWithFilter from "@/components/common/filters/ProductsSelectWithFilter";
import instance from "@/store/actions/instance";
import * as XLSX from "xlsx";
import InventoryExcelUploader from "./InventoryExcelUploader";
import BarcodeReader from "react-barcode-reader";

const { Option } = Select;
const EditableContext = React.createContext();

const EditableRow = ({ index, ...props }) => {
  return (
    <EditableContext.Provider>
      <tr {...props} />
    </EditableContext.Provider>
  );
};

const EditableCell = ({
  editable,
  children,
  record,
  handleSave,
  direction,
  initialValue,
  setInputRef,

  ...restProps
}) => {
  const [editing, setEditing] = useState(false);
  const inputRef = useRef();
  useEffect(() => {
    if (editing) {
      inputRef.current.focus();
    }
  }, [editing]);

  const toggleEdit = () => {
    setEditing(!editing);
  };

  const save = (e) => {
    toggleEdit();
    if (e.target.value && e.target.value !== initialValue)
      handleSave(Number(e.target.value));
  };

  if (editable) {
    children = editing ? (
      <InputNumber
        defaultValue={initialValue}
        ref={inputRef}
        onPressEnter={save}
        onBlur={save}
        style={{ direction: direction }}
        min={0}
      />
    ) : (
      <div
        className="editable-cell-value-wrap"
        ref={(node) => setInputRef(node)}
        style={{
          paddingRight: 24,
        }}
        onClick={toggleEdit}
      >
        {record.counted_quantity}
      </div>
    );
  }

  return <td {...restProps}>{children}</td>;
};
class StockUpdateOrderProductsTable extends Component {
  inputRefs = {};
  state = {
    loading: false,
    allProducts: null,
    excelModalOpen: false,
  };
  currency =
    this.props.config.language == "arabic"
      ? this.props.settings.currency_local
      : this.props.settings.currency_english;

  fetchProducts = async () => {
    this.setState({ loading: true });
    const { t, selectedOrder } = this.props;

    try {
      const res = await instance.post("/get_countable_products/", {});
      this.setState({ allProducts: res.data, loading: false });
    } catch (err) {
      if (err.response && err.response.status == 403)
        message.error(t("AccessDeniedMessage"));
      else message.error(err.response?.data?.error || t("SomethingWentWrong"));
    }
    this.setState({ loading: false });
  };
  renderColumnUnit = (unit, record, index) => {
    const { t, config, selectedOrder } = this.props;

    if (selectedOrder.status !== "New")
      return (
        <span>
          {(config.language === "arabic" && record.unit__ar_name) ||
            record.unit__name ||
            "-"}
        </span>
      );
    let productUnits = [];
    if (record.baseUnit?.id) {
      productUnits.push(
        <Option key={record.baseUnit?.id} value={record.baseUnit?.id}>
          {(config.language === "arabic" && record.baseUnit.ar_name) ||
            record.baseUnit.name}
        </Option>,
      );
    }
    record.units.forEach((unit) => {
      const unitName =
        config.language == "arabic"
          ? unit.unit__ar_name || unit.unit__name
          : unit.unit__name;

      productUnits.push(
        <Option value={unit.unit_id} key={unit.unit_id}>
          {unitName}
        </Option>,
      );
    });

    return productUnits.length > 1 ? (
      <Select
        style={{ width: "100%" }}
        placeholder={t("select a unit ")}
        defaultValue={unit.unit_id}
        onSelect={(unitId) => {
          const newProducts = [...this.props.products];
          newProducts[index].unit =
            record.units.find((u) => u.unit_id === unitId) || record.baseUnit;

          this.props.setProducts(newProducts);
        }}
      >
        {productUnits}
      </Select>
    ) : (
      <span>
        {(config.language === "arabic" &&
          (record.units[0] || record.baseUnit)?.unit__ar_name) ||
          (record.units[0] || record.baseUnit)?.unit__name ||
          "-"}
      </span>
    );
  };

  addProduct = (product) => {
    const { allProducts } = this.state;
    const selectedProduct = allProducts.find(
      (p) => p.id === product.product_id,
    );

    if (!selectedProduct) return null;

    return {
      product__name: selectedProduct.name,
      product__ar_name: selectedProduct.ar_name,
      product__sku: selectedProduct.sku,
      product_id: selectedProduct.id,
      id: selectedProduct.id,
      key: selectedProduct.id,
      type: "new-create",
    };
  };
  renderColumnDelete = (text, record, index) => {
    return (
      <Button
        disabled={record.type == "New"}
        onClick={() => {
          const newProducts = [...this.props.products];
          if (newProducts[index].type === "new-create") {
            newProducts.splice(index, 1);
          } else {
            newProducts[index].is_deleted = true;
          }
          this.props.setProducts(newProducts);
        }}
        danger
        shape="circle"
        icon={<DeleteOutlined style={{ top: 0 }} />}
      ></Button>
    );
  };
  renderColumnProduct = (productId, record, index) => {
    const { t, config, products } = this.props;
    const { allProducts, loading } = this.state;
    if (record.type !== "New") {
      return (
        <span style={{ whiteSpace: "break-spaces" }}>
          {`${
            (config.language === "arabic" && record.product__ar_name) ||
            record.product__name
          } ${record.product__sku} `}
        </span>
      );
    }
    const currentProductsIds = products
      .filter((p) => !p.is_deleted)
      .map((p) => p.product_id);
    return (
      <ProductsSelectWithFilter
        onSelect={async (newSelectedProduct) => {
          const selectedProduct = allProducts.find(
            (p) => p.id === newSelectedProduct,
          );
          const newProducts = [...this.props.products];

          const product = this.addProduct({
            product_id: selectedProduct.id,
          });
          if (product) {
            newProducts.push(product);
          }
          this.props.setProducts(newProducts);
        }}
        customFilter={(p) =>
          p.type_of_product === "stocked" &&
          !p.is_deleted &&
          !currentProductsIds.includes(p.id)
        }
        loading={this.state.loading}
        customProducts={this.state.allProducts}
      />
    );
  };
  beforeUpload = (file) => {
    const isExcel =
      file.type === "application/vnd.ms-excel" ||
      file.type ===
        "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet";
    if (!isExcel) {
      message.error("You can only upload Excel file!");
    }

    return isExcel;
  };

  handleExcelUpload = (file) => {
    const reader = new FileReader();

    reader.readAsBinaryString(file.file.originFileObj);
    reader.onload = (evt) => {
      const bstr = evt.target.result;
      const wb = XLSX.read(bstr, { type: "binary" });
      const products_sheet = wb.Sheets[wb.SheetNames[0]];
      const products = XLSX.utils.sheet_to_json(products_sheet, {
        blankrows: true,
        defval: null,
      });

      console.log(products);

      this.setState({ products });
    };
  };

  handleProductScan = (barcode) => {
    const { allProducts } = this.state;
    const { editMode, selectedOrder } = this.props;
    const scannedBarcode = String(barcode).trim();
    if (selectedOrder.status !== "New") return;

    if (!editMode) {
      this.inputRefs[scannedBarcode]?.click();
    } else if (editMode) {
      const scannedProduct = (allProducts || []).find(
        (p) =>
          String(p.barcode || "").trim() === scannedBarcode ||
          (p.additional_barcodes || []).some(
            (additionalBarcode) =>
              String(additionalBarcode).trim() === scannedBarcode,
          ),
      );
      if (
        scannedProduct &&
        !this.props.products.some((p) => p.product_id === scannedProduct?.id)
      ) {
        const newProducts = [...this.props.products];

        const product = this.addProduct({
          product_id: scannedProduct.id,
        });
        if (product) {
          newProducts.push(product);
        }
        this.props.setProducts(newProducts);
      }
    }
  };
  render() {
    const { loading, allProducts } = this.state;
    const {
      t,
      products,
      selectedOrder,
      settings,
      config,
      editMode,
      isViewOnly,
      permissions,
    } = this.props;

    const { excelModalOpen } = this.state;
    let columns = [
      {
        title: t("Product"),

        render: (productId, record, index) =>
          this.renderColumnProduct(productId, record, index),
      },

      {
        title:
          selectedOrder.type === "waste"
            ? t("Quantity Before Waste")
            : t("Expected Quantity"),
        dataIndex:
          selectedOrder.status === "New"
            ? "product__inventory_on_hand"
            : "expected_quantity",
        key: "product__inventory_on_hand",
        render: (value, record) =>
          `${value || 0} ${
            (config.language === "arabic" && record.product__unit__ar_name) ||
            record.product__unit__name ||
            ""
          }`,
      },
      {
        title:
          selectedOrder.type === "waste"
            ? t("Wasted Quantity")
            : t("Counted Quantity"),
        dataIndex: "counted_quantity",
        key: "counted_quantity",
        onCell: (record, index) => ({
          record,
          editable: selectedOrder.status === "New",
          initialValue: record.counted_quantity,
          handleSave: (newQuantity) => {
            if (newQuantity >= 0 && !Number.isNaN(newQuantity)) {
              const newProducts = [...this.props.products];
              newProducts[index].counted_quantity = newQuantity;
              this.props.setProducts(newProducts);
            }
          },
          setInputRef: (node) => {
            const barcodes = [
              record.product__barcode,
              ...(record.product__additional_barcodes || []),
            ];
            barcodes.forEach((productBarcode) => {
              if (productBarcode) {
                this.inputRefs[String(productBarcode).trim()] = node;
              }
            });
          },
        }),
      },
      {
        title: t("Unit"),
        dataIndex: "unit",
        key: "unit",
        render: (unit, record, index) =>
          this.renderColumnUnit(unit, record, index),
      },
    ];
    if (selectedOrder.type == "count") {
      columns.push({
        title: t("Difference"),
        key: "difference",
        render: (value, record) =>
          record.counted_quantity !== null
            ? `${
                record.counted_quantity *
                  (record.unit
                    ? record.unit.conversion_factor
                    : record.conversion_factor) -
                (selectedOrder.status === "Complete"
                  ? record.expected_quantity
                  : record.product__inventory_on_hand)
              } ${
                (config.language === "arabic" &&
                  record.product__unit__ar_name) ||
                record.product__unit__name ||
                ""
              }`
            : "-",
      });
    }
    if (editMode) {
      columns = [
        {
          title: t("Product"),

          render: (productId, record, index) =>
            this.renderColumnProduct(productId, record, index),
        },
        {
          title: t("Delete"),

          render: this.renderColumnDelete,
        },
      ];
    }
    return (
      <div>
        <BarcodeReader onScan={this.handleProductScan} />
        {excelModalOpen && (
          <InventoryExcelUploader
            type={"stock_update_order"}
            visible={excelModalOpen}
            selectedOrder={selectedOrder}
            onClose={async (shouldRefetch) => {
              this.setState({ excelModalOpen: false });
              if (shouldRefetch) {
                await this.props.fetchStockUpdateOrderDetails();
              }
            }}
          />
        )}
        {!editMode &&
          permissions.can_update_stock_update_orders &&
          ["New"].includes(selectedOrder.status) &&
          !isViewOnly && (
            <div
              style={{
                display: "flex",
                gap: 16,
                float: (config.language === "arabic" && "left") || "right",
              }}
            >
              <Button
                icon={<EditOutlined />}
                onClick={() => {
                  this.props.setEditMode(true);
                  if (!allProducts) {
                    this.fetchProducts();
                  }
                }}
                className="my-2"
              >
                {t("Add / Edit")}
              </Button>
              <Button
                icon={
                  <DownloadOutlined style={{ position: "relative", top: -2 }} />
                }
                onClick={() => {
                  this.setState({ excelModalOpen: true });
                }}
                className="my-2"
              >
                {t("Import")}
              </Button>
            </div>
          )}
        <Table
          dataSource={
            editMode ? [...products, { type: "New", units: [] }] : products
          }
          columns={columns}
          pagination={false}
          className="my-3"
          rowClassName={(record, index) =>
            record.is_deleted ? "d-none" : "text-center editable-row"
          }
          components={{
            body: {
              row: EditableRow,
              cell: EditableCell,
            },
          }}
        />
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    permissions: state.auth.permissions,
    settings: state.auth.settings,
    config: state.config,
    is_staff: state.auth.is_staff,
  };
};
const mapDispatchToProps = (dispatch) => {
  return {};
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(withNamespaces()(StockUpdateOrderProductsTable));
